const FreeFingerprintJS = import('@fingerprintjs/fingerprintjs');
import * as FingerprintJS from '@fingerprintjs/fingerprintjs-pro';

export interface IFingerprintService {
  getVisitorIdentifier(apiKey?: string): Promise<string>;
}

export default class FreeFingerprint implements IFingerprintService {
  async getVisitorIdentifier(): Promise<string> {
    try {
      const fpPromise = (await FreeFingerprintJS).load();
      const fpService = await fpPromise;
      const fpResponse = await fpService.get();
      return fpResponse?.visitorId || null;
    } catch (error) {
      console.error('[FreeFingerprint] An error has occurred while we try to get the fingerprint', error);
      return null;
    }
  }
}

export class PaidFingerprint implements IFingerprintService {
  async getVisitorIdentifier(apiKey: string): Promise<string> {
    try {
      const fpPromise = FingerprintJS.load({ apiKey: apiKey });
      const fpService = await fpPromise;
      const fpResponse = await fpService.get();
      return fpResponse?.visitorId || null;
    } catch (error) {
      console.error('[PaidFingerprint] An error has occurred while we try to get the fingerprint', error);
      return null;
    }
  }
}
